import { jsxs as l, Fragment as m, jsx as c } from "react/jsx-runtime";
import { message as d } from "antd";
import * as s from "react";
import { I as f } from "./AntdIcon-D8iup6xj.js";
var u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
function a() {
  return a = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      for (var t in o)
        Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
    }
    return r;
  }, a.apply(this, arguments);
}
const v = (r, e) => /* @__PURE__ */ s.createElement(f, a({}, r, {
  ref: e,
  icon: u
})), n = /* @__PURE__ */ s.forwardRef(v);
process.env.NODE_ENV !== "production" && (n.displayName = "CopyOutlined");
const y = ({
  text: r,
  children: e = /* @__PURE__ */ c(n, { className: "at-text-blue-500 hover:at-text-blue-500/70" }),
  messageConfig: o
}) => {
  const [t, i] = d.useMessage(o);
  return /* @__PURE__ */ l(m, { children: [
    i,
    /* @__PURE__ */ c("div", { onClick: ((p) => () => {
      navigator.clipboard ? navigator.clipboard.writeText(p).then(() => {
        t.success("複製成功");
      }).catch((h) => {
        t.error("OOPS! 複製失敗");
      }) : t.error("OOPS! 剪貼簿不可用");
    })(r), className: "at-cursor-pointer", children: e })
  ] });
};
export {
  y as C,
  n as R
};
